import { createGlobalStyle } from "styled-components";

export const CompilerLandingCss = createGlobalStyle`
    .dropdown-container {
        display: flex;
        flex-direction: row;
    }
`;
